<template>
  <div>
    <div v-if="!loaded" class="loadingFalse tableContainer">
      <div class="preloader">
        <span class="preloader-inner">
          <span class="preloader-inner-circle"></span>
        </span>
      </div>
    </div>
    <div v-else>
      <weather :title="station" wind-units="m/s" :current-day="currentDay" :forecast="forecast">
      </weather>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import format from 'date-fns/format';
import { defaultLocale } from '@/i18n/index';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import weather from './weather/vue-weather-component.vue';

export default {
  name: 'WeatherForecast',
  components: {
    weather,
  },
  data() {
    return {
      currentDay: null,
      forecast: [],
      loaded: false,
      data: null,
      ocultar: false
    };
  },
  computed: {
    getLanguage() {
      return this.enabled
        ? this.userProfile?.language || defaultLocale
        : defaultLocale;
    },
    ...mapState('contact', ['enabled']),
    ...mapGetters('userProfile', ['language']),
    ...mapState('weather', ['station']),
  },
  async beforeMount() {
    this.loaded = false;
    try {
      const data = await this.getWidgetData({
        initDate: format(
          new Date().setDate(new Date().getDate() - 1),
          'yyyy-MM-dd HH:mm:ss'
        ),
        endDate: format(
          new Date().setDate(new Date().getDate() + 7),
          'yyyy-MM-dd HH:mm:ss'
        ),
      });

      const weatherData = data[0].parameters;
      this.setStation(data[0].name || '');

      this.currentDay = {
        icon: weatherData.ICON[0].value.icon,
        code: weatherData.ICON[0].value.code,
        temp: weatherData.TEMPERATURE[0].value,
        currentSummary: weatherData.ICON[0].value.description,
        hourlySummary: '',
        windSpeed: weatherData.WIND_SPEED[0].value,
      };
      const forecasts = [];

      for (let i = 0; i < weatherData.ICON.length; i += 1) {
        forecasts.push({
          name: new Date(
            weatherData.ICON[i].date
          ).toLocaleDateString(this.getLanguage, {
            weekday: 'short',
          }),
          icon: weatherData.ICON[i].value.icon,
          highTemp: weatherData.TEMPERATURE_MAX_DAY[i].value,
          lowTemp: weatherData.TEMPERATURE_MIN_DAY[i].value,
          water: `${weatherData.PLUVIOMETER[i].value.toFixed(2)} mm`,
          wind: {
            value: weatherData.WIND_SPEED[i].value,
            direction: weatherData.WIND_DIRECTION[i].value,
          },
          sun: `${weatherData.SUN_HOURS[i].value.split(':')[0]}h`,
        });
      }

      this.forecast = forecasts;
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(
            this.$helpers.getFilteredErrorMessage(
              JSON.parse(error.message).error
            )
          ),
          width: 550,
        },
        'error',
        NOTIFY_TIME_LONG
      );
    } finally {
      this.loaded = true;
    }
  },
  methods: {
    ...mapActions('weather', ['getWidgetData', 'setStation']),
  },
};
</script>
